import React, { Component } from 'react';

class Leaves extends Component {
  
  render() {
    return (
      <div className="leaves"></div>
    );
  }
  
};

export default Leaves;